import { home } from './home';
import { settings } from './settings';

export const pages = {
  home,
  settings,
};
